import React, {useContext, useState} from 'react';
import {toast} from "react-toastify";
import pointLayerService from "../../../../../services/web/point-layer-service.js";
import projectUtils from "../../../../../utils/project-utils.js";
import {AreaLayerContext} from "../area-layer-context.jsx";
import areaLayerService from "../../../../../services/web/area-layer-service.js";

const ImportKmzKml = ({setShowKmzPanel, setKmzData}) => {
    const {setIsLoading} = useContext(AreaLayerContext)
    const [fileName, setFileName] = useState("Nenhum arquivo selecionado");

    const selectFile = ({target: {files}}) => {

        if (files[0].size >= 2 * Math.pow(1024, 2)) {
            toast.warning('O arquivo não pode ter mais de 2Mb');
            return;
        }

        if (files && files[0]) {
            setFileName(files[0].name)

            handleKmzFile(files[0])
        }
    }

    const handleKmzFile = (file) => {
        setIsLoading(true)

        const formData = new FormData();
        formData.append("file", file);

        areaLayerService.sendKmz(formData)
            .then(({data}) => {
                if (data.length > 0) {
                    setShowKmzPanel(true)
                    setKmzData(data)
                } else {
                    toast.warning('Erro ao carregar.');
                }
            })
            .catch((error) => {
                console.error(error);

                projectUtils.swalErrorMessage('', "Erro ao carregar.", 'Ok');
            })
            .finally(() => setIsLoading(false))
    }

    return (
        <>
            <label>Importar arquivo KMZ ou KML</label>
            <div className="flex h-8 w-full border border-gray-300 rounded-md overflow-hidden">
                <label className="w-26 p-1 flex items-center bg-gray-100 border-r border-gray-300 text-[11px] text-gray-700 cursor-pointer hover:bg-gray-200">
                    Selecione arquivo
                    <input type="file" className="hidden" onChange={selectFile}/>
                </label>

                <div className="flex items-center text-[11px] p-1 text-gray-500 w-[calc(100%-104px)]">
                    <span className={"truncate"}>{fileName}</span>
                </div>
            </div>
        </>
    );
};

export default ImportKmzKml;